import { render, staticRenderFns } from "./SelectComponent.vue?vue&type=template&id=e4476a82&scoped=true&"
import script from "./SelectComponent.vue?vue&type=script&lang=ts&"
export * from "./SelectComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SelectComponent.vue?vue&type=style&index=0&id=e4476a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4476a82",
  null
  
)

export default component.exports